export default __webpack_public_path__ + "img/book.a822f61b.png";